import { render, staticRenderFns } from "./CategoryView.vue?vue&type=template&id=3622cd4d"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"
import style0 from "./CategoryView.vue?vue&type=style&index=0&id=3622cd4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports